import { render, staticRenderFns } from "./JdOrderInfoCard_With_Img.vue?vue&type=template&id=bff7f006&scoped=true&"
import script from "./JdOrderInfoCard_With_Img.vue?vue&type=script&lang=js&"
export * from "./JdOrderInfoCard_With_Img.vue?vue&type=script&lang=js&"
import style0 from "./JdOrderInfoCard_With_Img.vue?vue&type=style&index=0&id=bff7f006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff7f006",
  null
  
)

export default component.exports